import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import BlankLayout from './layouts/BlankLayout'
import BlankLayoutWithAppBar from './layouts/BlankLayoutWithAppBar'
import './custom.css';
import ThemeComponent from './@core/theme/ThemeComponent'
import { SettingsConsumer, SettingsProvider } from './@core/context/settingsContext'
import ProtectedRoute from './ProtectedRoute'
import { store } from 'src/store'
import { Provider } from 'react-redux'

import { Toaster } from 'react-hot-toast'
import ReactHotToast from 'src/@core/styles/libs/react-hot-toast'
import Alert from './components/Alert';

export default class App extends Component {
    static displayName = App.name;

    render() {

        const setConfig = undefined;
        return (
            <Provider store={store}>
            <SettingsProvider {...(setConfig ? { pageSettings: setConfig() } : {})}>
                <SettingsConsumer>
                    {({ settings }) => {
                        return (
                            <ThemeComponent settings={settings}>
                                <Routes>
                                        {AppRoutes.map((route, index) => {
                                            const { element, requireAuth, ...rest } = route;
                                            return <Route key={index} {...rest} element={requireAuth ? <ProtectedRoute {...rest} ><BlankLayoutWithAppBar>{element}</BlankLayoutWithAppBar></ProtectedRoute> : <BlankLayout>{element}</BlankLayout>} />;
                                        })}
                                </Routes>
                                <ReactHotToast>
                                    <Toaster position={settings.toastPosition} toastOptions={{ className: 'react-hot-toast' }} />
                                </ReactHotToast>
                                <Alert />
                            </ThemeComponent>)
                    }}
                </SettingsConsumer>
                </SettingsProvider >
            </Provider>
        );
    }
}
